import localStorage from "fond/utils/localStorage";

const STORAGE_KEY = "FOND_DRAW_TOOL_PREFERENCES";

interface SnapOptions {
  snapPx: number;
  snapPointPx?: number;
  snapToMidPoints: boolean;
  snapVertexPriorityDistance: number;
}

export interface DrawToolPreferences {
  snapOptions: SnapOptions;
}

const DEFAULT_PREFERENCES: DrawToolPreferences = {
  snapOptions: {
    snapPx: 15,
    snapToMidPoints: false,
    snapVertexPriorityDistance: 0.0025,
  },
};

/**
 * Reads draw tool preferences from localStorage, merging with defaults
 * to handle missing fields from older schemas.
 */
export const getDrawToolPreferences = (): DrawToolPreferences => {
  const stored = localStorage.getItem(STORAGE_KEY) as unknown;
  const storedObj = stored && typeof stored === "object" ? (stored as Partial<DrawToolPreferences>) : undefined;

  const result = {
    snapOptions: {
      ...DEFAULT_PREFERENCES.snapOptions,
      ...(storedObj?.snapOptions && typeof storedObj.snapOptions === "object" ? storedObj.snapOptions : undefined),
    },
  };
  return result;
};

type DrawToolPreferencesUpdate = {
  [K in keyof DrawToolPreferences]?: DrawToolPreferences[K] extends object ? Partial<DrawToolPreferences[K]> : DrawToolPreferences[K];
};

/**
 * Persists a partial update to draw tool preferences.
 * Deep-merges snapOptions so individual values can be updated without replacing the whole object.
 */
export const saveDrawToolPreferences = (preferences: DrawToolPreferencesUpdate): void => {
  const current = getDrawToolPreferences();
  const updated: DrawToolPreferences = {
    ...current,
    ...preferences,
    snapOptions: {
      ...current.snapOptions,
      ...(preferences.snapOptions || {}),
    },
  };
  localStorage.setItem(STORAGE_KEY, updated);
};
